export enum SiglaMomentoDisparoRegraEtiqueta {
    TAREFA_DISTRIBUICAO = 'TAREFA_DISTRIBUICAO',
    PROCESSO_PRIMEIRA_TAREFA = 'PROCESSO_PRIMEIRA_TAREFA',
    PROCESSO_DISTRIBUICAO = 'PROCESSO_DISTRIBUICAO',
    PROCESSO_CRIACAO_PROCESSO_ADMINISTRATIVO = 'PROCESSO_CRIACAO_PROCESSO_ADMINISTRATIVO',
}
